import React from 'react';

const Footer = () => {
    return (
        <footer className="hidden">        	
            <div id="footer-container">
                <div id="backtotop" className="button-wrap left">
                    <div className="icon-wrap parallax-wrap">
                        <div className="button-icon parallax-element">
                            <i className="arrow-icon-up"></i>
                        </div>
                    </div>
                    <div className="button-text sticky left"><span data-hover="Back Top">Back Top</span></div> 
                </div>
                <div className="footer-middle">
                    <div className="copyright"><a className="link" target="_blank" href="https://h3m.studio">H3M Inc.</a> © 2023</div>
                </div>
                <div className="socials-wrap">            	
                    <div className="socials-icon">
                        <i className="fa-solid fa-share-nodes"></i>
                    </div>
                    <div className="socials-text">Follow Us</div>
                    <ul className="socials">
                        <li><span className="parallax-wrap"><a className="parallax-element" href="" target="_blank">Ig</a></span></li>
                        <li><span className="parallax-wrap"><a className="parallax-element" href="" target="_blank">Tw</a></span></li>
                        <li><span className="parallax-wrap"><a className="parallax-element" href="" target="_blank">Tl</a></span></li>
                        <li><span className="parallax-wrap"><a className="parallax-element" href="" target="_blank">Dc</a></span></li>
                        <li><span className="parallax-wrap"><a className="parallax-element" href="" target="_blank">In</a></span></li>
                    </ul>                
                </div>
            </div>
        </footer>
    )
}

export default Footer;